// src/component/PAR/PARTabNav.jsx
import React from "react";

export default function PARTabNav({ tabs, activeTab, onTabChange }) {
  return (
    <nav className="mb-5 flex flex-wrap gap-x-7 gap-y-2 border-b border-gray-200">
      {tabs.map(({ key, label }) => {
        const isActive = activeTab === key;
        return (
          <button
            key={key}
            onClick={() => onTabChange(key)}
            className={`relative pb-3 text-sm ${
              isActive ? "font-semibold text-green-600" : "font-medium text-gray-700 hover:text-green-700"
            }`}
          >
            {label}
            {isActive && <span className="absolute inset-x-0 -bottom-px h-0.5 rounded bg-green-600" />}
          </button>
        );
      })}
    </nav>
  );
}
